import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext } from 'react';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { StripeCardForm } from './StripeCardForm';
import { BraintreeCardForm } from './BraintreeCardForm';
import { AdyenCardForm } from './AdyenCardForm';
import { NuveiCardForm } from './NuveiCardForm';
import { ChargebeeCardForm } from './ChargebeeCardForm';
import { AppchargePaymentElementForm } from './AppchargePaymentElementForm';

export const NewCardForm = () => {
  const { paymentMethodsSettings, checkoutConfiguration } = useContext(CheckoutContext);
  const cardSettings = paymentMethodsSettings.find((pm) => pm.paymentMethodName === PaymentMethodEnum.CREDIT_CARD);
  if (!cardSettings) return null;

  if (checkoutConfiguration?.isRawPanSelfManaged) {
    return <AppchargePaymentElementForm />;
  }

  if (cardSettings.provider === ProviderEnum.STRIPE) {
    return <StripeCardForm />;
  }

  if (cardSettings.provider === ProviderEnum.BRAINTREE) {
    return <BraintreeCardForm />;
  }
  if (cardSettings.provider === ProviderEnum.ADYEN) {
    return <AdyenCardForm />;
  }
  if (cardSettings.provider === ProviderEnum.NUVEI) {
    return <NuveiCardForm />;
  }
  if (cardSettings.provider === ProviderEnum.CHARGEBEE) {
    return <ChargebeeCardForm />;
  }

  return null;
};
